import type { CloudpackConfig, RemoteCacheConfig } from '@ms-cloudpack/common-types';

/**
 * Ensures that the remote cache is enabled in the config.
 * @param config  - The cloudpack config.
 * @returns - The remote cache configuration.
 */
export function ensureRemoteCacheEnabled({ remoteCache }: CloudpackConfig): RemoteCacheConfig {
  if (!remoteCache) {
    throw new Error('Remote cache is not configured. Please add remoteCache to your cloudpack.config.json file.');
  }

  return remoteCache;
}
